var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "72px",
    viewBox: "0 0 96 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Check-large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client---revoke-access-success-Copy-2",
    transform: "translate(-591.000000, -352.000000)",
    fill: "#00D592",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(382.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.000000, 98.000000)",
    id: "Icon/Close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.8,37.8 L54,93.6 L34.2,73.8 C31.8,71.4 28.2,71.4 25.8,73.8 C23.4,76.2 23.4,79.8 25.8,82.2 L49.8,106.2 C51,107.4 52.2,108 54,108 C55.8,108 57,107.4 58.2,106.2 L118.2,46.2 C120.6,43.8 120.6,40.2 118.2,37.8 C115.8,35.4 112.2,35.4 109.8,37.8 Z",
    id: "Fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneGreen);
export default __webpack_public_path__ + "static/media/done-green.a4cf755e704dbb92c1e04868b394689d.svg";
export { ForwardRef as ReactComponent };